import {
  ChatBubbleBottomCenterIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { CreateCourseDTO } from "@onetutor/shared/dto";
import { CourseFeatures } from "@onetutor/shared/type";
import { SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface CourseFeatureToggleProps {
  enabledFeatures: CourseFeatures[];
  setCourse: (value: SetStateAction<CreateCourseDTO>) => void;
}

const CourseFeatureToggle = ({
  enabledFeatures,
  setCourse,
}: CourseFeatureToggleProps) => {
  const { t } = useTranslation(["courseManagementPage", "commons"]);
  const [chatEnabled, setChatEnabled] = useState(false);
  const [quizEnabled, setQuizEnabled] = useState(false);

  useEffect(() => {
    setChatEnabled(enabledFeatures.includes(CourseFeatures.CHAT));
    setQuizEnabled(enabledFeatures.includes(CourseFeatures.QUIZ));
  }, [enabledFeatures]);

  const updateFeatures = (chat: boolean, quiz: boolean) => {
    const newFeatures: CourseFeatures[] = [];
    if (chat) {
      newFeatures.push(CourseFeatures.CHAT);
    }
    if (quiz) {
      newFeatures.push(CourseFeatures.QUIZ);
    }

    setCourse((prev) => ({
      ...prev,
      enabledFeatures: newFeatures,
    }));
  };

  return (
    <div>
      <span className="font-semibold text-lg">{t("courseFeatures")}</span>
      <div className="my-sm">
        <div className="mb-sm flex flex-row items-center">
          <input
            type="checkbox"
            className="toggle mr-md"
            checked={chatEnabled}
            onChange={(e) => {
              const newChatEnabled = e.target.checked;
              setChatEnabled(newChatEnabled);
              updateFeatures(newChatEnabled, quizEnabled);
            }}
          />
          <ChatBubbleBottomCenterIcon
            className={`h-6 w-6 ${!chatEnabled ? "opacity-50" : ""}`}
          />
          <p
            className={`ml-sm font-semibold text-lg ${!chatEnabled ? "opacity-50" : ""}`}
          >
            {t("chatFeature")}
          </p>
        </div>

        <div className="mb-sm flex flex-row items-center">
          <input
            type="checkbox"
            className="toggle mr-md"
            checked={quizEnabled}
            onChange={(e) => {
              const newQuizEnabled = e.target.checked;
              setQuizEnabled(newQuizEnabled);
              updateFeatures(chatEnabled, newQuizEnabled);
            }}
          />
          <QuestionMarkCircleIcon
            className={`h-6 w-6 ${!quizEnabled ? "opacity-50" : ""}`}
          />
          <p
            className={`ml-sm font-semibold text-lg ${!quizEnabled ? "opacity-50" : ""}`}
          >
            {t("quizFeature")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CourseFeatureToggle;
